import { GlobalStyles } from '@mui/material';

// iOS Safari zooms the whole page into any text field whose font is smaller
// than 16 px, and many fields set 12-13 px inline. On phones every input,
// textarea and select is raised to 16 px; !important wins over the inline sx.
//
// "Phone" is two cases: a narrow window (< 600 px, portrait), and a touch
// device that is still below the 900 px tab bar breakpoint, which covers most
// iPhones turned sideways (667-852 px wide; the largest are 926-932 px and
// already get the tablet layout) and iPads in portrait. A desktop browser
// window dragged narrow has a mouse (pointer: fine) and keeps the compact
// fields.
const SIXTEEN_PX = {
    'input, textarea, select': { fontSize: '16px !important' },
};

export function MobileGlobalStyles() {
    return (
        <GlobalStyles
            styles={theme => ({
                [theme.breakpoints.down('sm')]: SIXTEEN_PX,
                [`${theme.breakpoints.down('md')} and (pointer: coarse)`]:
                    SIXTEEN_PX,
            })}
        />
    );
}
